import { Text } from '~/components/ui/Text';
import { getPlateSlots } from '../PreviewClassic/PreviewClassic.model';
import {
	StyledBgLine,
	StyledBottomLetters,
	StyledContainer,
	StyledCountryContainer,
	StyledDigits,
	StyledRegion,
	StyledRegionContainer,
	StyledSlot,
	StyledStroke,
	StyledTopLetter,
} from './PreviewClassicSquare.styled';

const PreviewClassicSquare = ({
	number,
	region,
}: {
	number: string;
	region: string;
}) => {
	const slots = getPlateSlots(number);

	return (
		<StyledContainer>
			<StyledStroke />
			<StyledBgLine />
			<StyledTopLetter>
				<StyledSlot $letter={slots[0]?.value}>
					{slots[0]?.value || ' '}
				</StyledSlot>
			</StyledTopLetter>
			<StyledDigits>
				<StyledSlot>{slots[1]?.value || ' '}</StyledSlot>
				<StyledSlot>{slots[2]?.value || ' '}</StyledSlot>
				<StyledSlot>{slots[3]?.value || ' '}</StyledSlot>
			</StyledDigits>
			<StyledBottomLetters>
				<StyledSlot $letter={slots[4]?.value}>
					{slots[4]?.value || ' '}
				</StyledSlot>
				<StyledSlot $letter={slots[5]?.value}>
					{slots[5]?.value || ' '}
				</StyledSlot>
			</StyledBottomLetters>
			<StyledRegionContainer
				style={{
					right: 28,
				}}
			>
				<StyledRegion>{region.slice(0, 2)}</StyledRegion>
				<StyledCountryContainer>
					<Text>RUS</Text>
					{/* {type === VehicleNumberPlateType.ClassicSquare && (
						<img src={flagImg} />
					)} */}
				</StyledCountryContainer>
			</StyledRegionContainer>
		</StyledContainer>
	);
};

export { PreviewClassicSquare };
